<template>
 <div style="text-align:center;"
  :style="{ background: `url(${require('@image/productSystemMobile_bg.png')})`, 'background-size': 'cover' }"
  class="scene-pc">
  <span class="home-scene-title">产品体系</span>
  <div class="home-scene-cards">
   <a-card hoverable class="home-scene-card" v-for="item in dataList" :key="item.id">
    <template #cover>
     <div>
      <img class="card-img" alt="example" :src="getImgUrl(item)" />
     </div>
    </template>
    <a-card-meta>
     <template #title>
      <span class="card-title">{{ item.input988275a1 }}</span>
     </template>
     <template #description>
      <div class="card-text card-text-mobile">{{ item.inputde060c84 }}</div>
     </template>
    </a-card-meta>
   </a-card>



  </div>
  <learnmore path="/product"></learnmore>
 </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import learnmore from "@/components/learnmore.vue"

const props = defineProps({
 dataList: {
  type: Array,
  default: () => []
 }
})
const getImgUrl = (item) => {
 if (item['picture-uploadc8da899c'] && item['picture-uploadc8da899c'].length > 0) {
  return item['picture-uploadc8da899c'][0].url
 } else {
  return ""

 }
}
const dataList = computed(() => props.dataList)



</script>

<style lang="less" scoped>
.scene-pc {
 font-family: 'PuHuiTi';
}

.home-scene-title {

 font-size: 36px;
 font-weight: 500;
 line-height: 24px;
 letter-spacing: 1px;
 color: #333333;
}

.home-scene-cards:hover {
 animation-play-state: paused;
 -webkit-animation-play-state: paused
}

.home-scene-cards {
 margin-top: 8rem;

 display: flex;
 justify-content: flex-start;
 overflow-x: scroll;

 display: flex;
 width: fit-content;

 animation: scene-rolling 60s linear infinite;

 .home-scene-card {
  margin-right: 3rem;
  margin-bottom: 3rem;

  opacity: 1;
  background: #FFFFFF;
  overflow: hidden;


  .card-img {

   width: 100%;
   height: 100%;
  }

  .card-title {
   font-family: "PuHuiTiRegular";
   font-size: 20px;
   font-weight: bold;

   color: #333333;
  }

  .card-text {
   font-family: "PuHuiTiRegular";
   font-size: 14px;
   font-weight: 350;
   color: #666666;
   height: 85px;
   overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 4;
   -webkit-box-orient: vertical
  }
 }

 .home-scene-card:hover {
  box-shadow: 0px 8px 12px 0px rgba(13, 126, 115, 0.1);
 }
}

.home-scene-cards::-webkit-scrollbar {
 display: none;
}

@keyframes scene-rolling {
 0% {
  -webkit-transform: translateX(0);
  transform: translateX(0)
 }

 to {
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%)
 }
}

@media screen and (max-width: 800px) {


 .home-scene-card {
  border-radius: 5px;
  height: 61rem;
  width: 56rem;
 }

 .scene-pc {
  padding-top: 40px;
  padding-bottom: 20px;
 }
}

@media screen and (max-width: 1000px) {}

@media screen and (min-width: 800px) {
 .scene-pc {
  margin-top: 120px;
  padding: 100px;
 }

 .home-scene-card {
  height: 41.4rem;
  width: 41.2rem;
  border-radius: 10px;
 }
}
</style>

<style>
.home-scene-cards .ant-card-body {
 padding: 2.4rem;
}
</style>
